import Title from '../../@iosper/components/Page/Title';
import { InternacionesMain } from '../pages';

export const Internaciones = () => {
  return (
    <>
      <Title autoFocus={false}>Internaciones</Title>
      <InternacionesMain />
    </>
  );
};